(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
      };
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ufood-blog-featured"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-ufood-blog-slide]');
    if (!button) return;
    const track = document.getElementById(button.getAttribute('aria-controls'));
    const card = track && track.querySelector('.ufood-blog-featured__card');
    if (!card) return;
    const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
    track.scrollBy({left: button.dataset.ufoodBlogSlide === 'next' ? distance : -distance, behavior: 'smooth'});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ufood-home-categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-ufood-slide]');
    if (!button) return;
    const track = document.getElementById(button.getAttribute('aria-controls'));
    if (!track) return;
    const card = track.querySelector('.ufood-home-category__card');
    if (!card) return;
    const amount = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    track.scrollBy({ left: button.dataset.ufoodSlide === 'next' ? amount : -amount, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
